import {Icon} from '@/app/components/Icon';
import {NavLink, Outlet, useLocation, useNavigate} from 'react-router-dom';
import {ChoiceSelect} from '@/components/app/choice-select';
import {cn} from '@/lib/utils';

const profileLinkClass = ({isActive}: {isActive: boolean}) =>
  cn(
    'flex w-full items-center gap-2 px-4 py-3 text-sm font-medium text-primary hover:bg-muted hover:no-underline',
    isActive && 'bg-muted',
  );
export const Profile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div className="md:h-full">
      <div className="page-container pt-6 h-full">
        <div className="flex flex-wrap -mx-3 -mt-3 h-full">
          <div className="w-full px-3 pt-3 md:w-3/12 md:px-3 md:pt-3">
            <div className="hidden md:block bg-white py-6 shadow-md rounded-xl">
              <NavLink className={profileLinkClass} to="account-info">
                <Icon icon="user" />
                Account Info
              </NavLink>
              <NavLink className={profileLinkClass} to="membership">
                <Icon icon="dollar" />
                Subscription & Billing
              </NavLink>
              <NavLink className={profileLinkClass} to="notifications">
                <Icon icon="bell" />
                Notifications
              </NavLink>
            </div>
            <ChoiceSelect
              className="w-full md:hidden"
              onValueChange={(e) => {
                navigate(e);
              }}
              options={[
                {
                  label: 'Account Info',
                  value: 'account-info',
                },
                {
                  label: 'Subscription & Billing',
                  value: 'membership',
                },
                {
                  label: 'Notifications',
                  value: 'notifications',
                },
              ]}
              optionLabel="label"
              optionValue="value"
              value={location.pathname.split('/').reverse()[0]}
            />
          </div>
          <div className="w-full px-3 pt-3 md:w-9/12 md:px-3 md:pt-3 h-full">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
